export const RESIDENCE_OPTIONS = [
  {
    label: 'Inside U.S',
    value: 'inside',
  },
  {
    label: 'Outside U.S',
    value: 'outside',
  },
]
